import { WaveFile } from 'wavefile';
import { getLogger } from '../../../../util/logger';
import {
  addNewPrompt,
  applyDefaultPrompt,
  removeNewPrompt,
} from '../../utils/settingsUtils';

const logger = getLogger('settingsUtil');

export const handleAudioChange = (
  event,
  name,
  defaultAudioUrl,
  setPromptChanges,
  setSubmitEnabled,
  setFieldValue,
) => {
  setFieldValue(name, event.currentTarget.files[0]);
  addNewPrompt(
    setPromptChanges,
    setSubmitEnabled,
    defaultAudioUrl,
    event.currentTarget.files[0],
    false,
  );
};

export const handleAudioLoad = async (
  uploadedFile,
  currentAudioUrl,
  setPromptError,
  setShowPromptError,
  clearAudio,
) => {
  let buffer;
  if (uploadedFile) {
    buffer = await uploadedFile.arrayBuffer();
  } else {
    const blob = await fetch(currentAudioUrl, {
      cache: 'no-cache',
    }).then((value) => value.blob());
    buffer = await blob.arrayBuffer();
  }

  let errorMsg = null;

  try {
    const wav = new WaveFile(new Uint8Array(buffer));
    if (wav.bitDepth !== '16') {
      errorMsg = `Must be a 16-bit wav file`;
    } else if (wav.fmt.audioFormat !== 1) {
      // more details regarding the wFormatTag here:
      // https://docs.microsoft.com/en-us/windows/win32/api/mmreg/ns-mmreg-waveformatex
      // Uncompressed audio types:
      // https://docs.microsoft.com/en-us/windows/win32/directshow/audio-subtypes

      errorMsg = `Must use the PCM waveform audio format.`;
    } else if (wav.fmt.numChannels !== 1) {
      errorMsg = `Must use monophonic audio`;
    } else if (wav.fmt.sampleRate !== 16000) {
      errorMsg = 'Must be 16kHz';
    }
  } catch (error) {
    logger.error(error);
    errorMsg = `Error: ${error.message}`;
  } finally {
    if (errorMsg != null) {
      setPromptError({
        title: 'Invalid Audio File',
        message: errorMsg,
        isSlide: false,
      });
      setShowPromptError(true);
      clearAudio();
    }
  }
};

export const clearCustomAudio = (
  name,
  isNew,
  audioRef,
  audioUrl,
  defaultAudioUrl,
  currentAudioUrl,
  setPromptChanges,
  clearInputValue,
  setFieldValue,
  setCurrentAudioUrl,
) => {
  if (isNew) {
    URL.revokeObjectURL(audioRef.current.audioEl.current.src);
    setFieldValue(name, undefined);
    // inputRef.current.value = [];
    clearInputValue();

    if (audioUrl !== defaultAudioUrl && currentAudioUrl === defaultAudioUrl) {
      applyDefaultPrompt(setPromptChanges, defaultAudioUrl);
    } else {
      removeNewPrompt(setPromptChanges, defaultAudioUrl);
    }
  } else {
    setCurrentAudioUrl(defaultAudioUrl);
    applyDefaultPrompt(setPromptChanges, defaultAudioUrl);
  }
};
